import { COUNTRY_CONFIGS, DEFAULT_COUNTRY } from "../Config/countryConfig";

export const parsePhoneNumber = (fullNumber) => {
  if (!fullNumber) {
    return { dialCode: DEFAULT_COUNTRY.dialCode, contactNumber: "", countryCode: DEFAULT_COUNTRY.code };
  }

  // Clean all spaces and pluses
  const cleanNumber = String(fullNumber).replace(/[\s+]/g, "");

  // Find a matching country dial code (sort by dialCode length descending to match longest code first)
  const sortedConfigs = [...COUNTRY_CONFIGS].sort(
    (a, b) => b.dialCode.length - a.dialCode.length
  );
  const matchedConfig = sortedConfigs.find((config) => {
    const dialCodeWithoutPlus = config.dialCode.replace("+", "");
    return cleanNumber.startsWith(dialCodeWithoutPlus);
  });

  if (matchedConfig) {
    const dialCodeWithoutPlus = matchedConfig.dialCode.replace("+", "");
    return {
      dialCode: matchedConfig.dialCode,
      contactNumber: cleanNumber.slice(dialCodeWithoutPlus.length),
      countryCode: matchedConfig.code,
    };
  }

  // Fallback: Default country
  return {
    dialCode: DEFAULT_COUNTRY.dialCode,
    contactNumber: cleanNumber,
    countryCode: DEFAULT_COUNTRY.code,
  };
};

export const formatPhoneNumber = (fullNumber) => {
  if (!fullNumber) return "--";

  const { dialCode, contactNumber } = parsePhoneNumber(fullNumber);
  return `${dialCode} ${contactNumber}`;
};

export const getCountryConfigByDialCode = (dialCode) => {
  return COUNTRY_CONFIGS.find((c) => c.dialCode === dialCode) || DEFAULT_COUNTRY;
};

export const getCountryConfigByCode = (code) => {
  return COUNTRY_CONFIGS.find((c) => c.code === code) || DEFAULT_COUNTRY;
};

export const validatePhoneNumberLength = (contactNumber, dialCode) => {
  if (!contactNumber) return true;
  const config = getCountryConfigByDialCode(dialCode);
  if (!config) return true;

  if (Array.isArray(config.length)) {
    if (!config.length.includes(contactNumber.length)) {
      return config.validationMessage || `Contact number must be ${config.length.join(" or ")} digits`;
    }
  } else if (config.length && contactNumber.length !== config.length) {
    return config.validationMessage || `Contact number must be exactly ${config.length} digits`;
  }
  return true;
};

